export const doUppercaseFirstLetter = (pWord: string) => {
  return pWord?.charAt(0).toUpperCase() + pWord?.slice(1);
};
